import React, { useEffect, useState } from "react";
import { Drawer, Form, Button, Tabs } from "antd";
import BasicSection from "./sections/BasicSection";
import MainFeaturesSection from "./sections/MainFeaturesSection";
import CompareSection from "./sections/CompareSection";
import OverviewSection from "./sections/OverviewSection";
import MediaSection from "./sections/MediaSection";
import api from "../../api";

export default function InsuranceFormDrawer({
  open,
  onClose,
  editingRow,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [issuerOptions, setIssuerOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const isEdit = !!editingRow;

  useEffect(() => {
    api.issuers_list({ limit: 100 }).then((res) => {
      if (res?.status === 200)
        setIssuerOptions(
          res.data.data.map((i) => ({ value: i.id, label: i.name })),
        );
    });
    api
      .categories_list({ limit: 100, productType: "INSURANCE" })
      .then((res) => {
        if (res?.status === 200)
          setCategoryOptions(
            res.data.data.map((c) => ({ value: c.id, label: c.label })),
          );
      });
  }, []);

  useEffect(() => {
    if (open && editingRow) {
      form.setFieldsValue({
        ...editingRow,
        featured: editingRow.featured ?? false,
        issuerId: editingRow.issuer?.id,
        categoryId: editingRow.categories?.[0]?.id || undefined,
        keyFacts: editingRow.keyFacts || [],
        pros: editingRow.pros || [],
        cons: editingRow.cons || [],
        coverageRisks: editingRow.coverageRisks || [],
        ownLiability: editingRow.ownLiability || [],
        claimConditions: editingRow.claimConditions || [],
        additionalConditions: editingRow.additionalConditions || [],
      });
    } else if (open) {
      form.resetFields();
    }
  }, [open, editingRow]);

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      const res = isEdit
        ? await api.insurances_update(editingRow.id, values)
        : await api.insurances_create(values);
      if (res?.status === 200 || res?.status === 201) {
        onSuccess(res.data, isEdit);
        onClose();
      }
    } catch {
    } finally {
      setSaving(false);
    }
  };

  const tabs = [
    {
      key: "basic",
      label: "Үндсэн",
      children: (
        <BasicSection
          issuerOptions={issuerOptions}
          categoryOptions={categoryOptions}
        />
      ),
    },
    { key: "main", label: "Үндсэн онцлог", children: <MainFeaturesSection /> },
    { key: "compare", label: "Нарийвчилсан", children: <CompareSection /> },
    { key: "overview", label: "Тойм", children: <OverviewSection /> },
    { key: "media", label: "Медиа", children: <MediaSection /> },
  ];

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={isEdit ? "Даатгал засах" : "Даатгал нэмэх"}
      width={520}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <Button onClick={onClose}>Болих</Button>
          <Button type="primary" loading={saving} onClick={onSave}>
            {isEdit ? "Хадгалах" : "Нэмэх"}
          </Button>
        </div>
      }
    >
      <Form form={form} layout="vertical">
        <Tabs items={tabs} />
      </Form>
    </Drawer>
  );
}
